import type { Target } from '@harnessio/ff-nodejs-server-sdk';

import { FeatureFlagService } from '../FeatureFlagService';
import { FEATURE_FLAGS } from '../interfaces';

export const fetchFlag = async (flag: FEATURE_FLAGS, options: { target?: Target; enableStream?: boolean }) => {
  const featureFlagToken = process.env['FEATURE_FLAG_API_KEY_SERVER'];

  const featureFlagService = new FeatureFlagService(featureFlagToken || '', options);

  console.log('----------->', featureFlagService);

  const flags = await featureFlagService.getFlags([flag], options);

  return flags;
};
